// https://tracker.yandex.ru/GP-1499
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('a[href^="mailto:"]').forEach(link => {
        link.removeAttribute('href')
    })
})
